import React, { useState } from 'react'
import SupplyBillItemsTable from './SupplyBillItemsTable'
import SupplyBillItemList from './list/SupplyBillItemList'

const SupplyBilItemsInBill = ({ supplyBillId }) => {

	const [checked, setChecked] = useState([])

  return (
    <div>
        <h4>Позиції рахунку</h4>

        {/* <SupplyBillItemsTable 
            // supplyBillItems={supplyBillItems}
			checked={checked}
			setChecked={setChecked}
        /> */}

		<SupplyBillItemList />
    </div>
  )
}

export default SupplyBilItemsInBill